
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/overview",
      function () {
        return require("private-next-pages/terminal/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/overview"])
      });
    }
  